export const APP_NAME = 'credit-decision';

export const CREDIT_DECISION_ROUTE_ROOT = '/creditDecision';
